import React, { Fragment, memo, useEffect, useState } from 'react';
import { FaCaretDown, FaCaretUp } from 'react-icons/fa';

const default_odd_value = Number(0).toFixed(2);

// 🔁 Make arrows blink with setInterval (optional)
const ArrowDown = memo(() => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const id = setInterval(() => setShow(prev => !prev), 2000);
    return () => clearInterval(id);
  }, []);

  return <Fragment>{show && <FaCaretDown className="text-danger" />}</Fragment>;
});

const ArrowUp = memo(() => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const id = setInterval(() => setShow(prev => !prev), 2000);
    return () => clearInterval(id);
  }, []);

  return <Fragment>{show && <FaCaretUp className="text-warning" />}</Fragment>;
});

function Odd({ lv, v }) {
  const currNum = Number(v);
  const prevNum = Number(lv);

  const hasCurr = Number.isFinite(currNum);

  // ✅ treat lv=0 as "unknown previous"
  const hasPrev = Number.isFinite(prevNum) && prevNum > 0;

  const curr = hasCurr ? currNum.toFixed(2) : default_odd_value;

  return (
    <span>
      {curr}
      {hasCurr && hasPrev && currNum < prevNum && <ArrowDown />}
      {hasCurr && hasPrev && currNum > prevNum && <ArrowUp />}
    </span>
  );
}


export default Odd;
